


































































































































































































import "./member-setup.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import Modal from "../../components/common/confirm.js";

export default Vue.extend({
  name: "member-setup",
  components: { UserAvatar },
  props: {
    member: Object,
    showSetup: Boolean,
  },
  data() {
    return {
      listMode: false,
      currentPage: "members",
      currentMember: null,
      changingRoleByUser: true,
      currentMemberOriginalRole: null,
      rules: {
        role: [
          {
            required: true,
            message: "Please choose permission",
            trigger: "blur",
          },
        ],
      },
      sending: false,
      inviteModel: {
        memberId: null,
        role: null,
      },
      inviteFormRules: {
        memberId: [
          {
            type: "number",
            required: true,
            message: "Please select a user",
            trigger: "blur",
          },
        ],
        role: [
          {
            type: "number",
            required: true,
            message: "Please select a role",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.listMode = this.member ? false : true;
        this.currentPage = "members";
        if (this.member) {
          this.assignCurrentMember(this.member);
          this.currentPage = "member";
        }
      }
    },
  },
  computed: {
    ...mapState("billing", ["billingAccount"]),
    ...mapState("review", ["currentReview"]),
    ...mapGetters("review", ["currentReviewInviteRoles", "getRoleDetails", "roleTitle", "parentRoleTitle", "childRoleTitle"]),
    showModal: {
      get: function () {
        return (this as any).showSetup;
      },
      set: function (newValue) {
        (this as any).$emit("cancel");
      },
    },
    allMembers() {
      let context = this as any;
      let review = context.$store.state.review.currentReview;
      let members = review && review.members ? review.members : [];
      if (members === null) {
        members = [];
      }

      return members.map((member, index) => {
        return {
          adminFlag: "",
          memberId: member.memberId,
          memberName: member.memberName,
          memberEmailAddress: member.memberEmailAddress,
          memberPhoneNumber: member.memberPhoneNumber,
          memberAvatarImageUrl: member.memberAvatarImageUrl,
          role: member.role,
        };
      });
    },
    parentMembers() {
      let allMembers = this.allMembers;

      if (allMembers && allMembers.length > 0) {
        return allMembers.filter((member) => member.role == 1);
      } else {
        return [];
      }
    },
    childMembers() {
      let allMembers = this.allMembers;

      if (allMembers && allMembers.length > 0) {
        return allMembers.filter((member) => member.role == 2);
      } else {
        return [];
      }
    },
    guestMembers() {
      let allMembers = this.allMembers;
      if (allMembers && allMembers.length > 0) {
        return allMembers.filter((member) => member.role == 4);
      } else {
        return [];
      }
    },
    authorOnlyMembers() {
      let allMembers = this.allMembers;

      if (allMembers && allMembers.length > 0) {
        return allMembers.filter((member) => member.role == 5);
      } else {
        return [];
      }
    },
    pageTitle() {
      if (this.currentPage == "members") {
        return "Review Role Assignments";
      } else if (this.currentPage == "member") {
        return "User";
      } else if (this.currentPage == "invite") {
        return "Invite";
      } else if (this.currentPage == "remove") {
        return "Remove User?";
      } else {
        return "";
      }
    },
    showPageTitle() {
      return !(!this.listMode && this.currentPage == "member");
    },
    showBackButton() {
      return !((!this.listMode && this.currentPage == "member") || (this.listMode && this.currentPage == "members"));
    },
    accountUsers() {
      let context = this as any;
      let members = context.billingAccount && context.billingAccount.members ? context.billingAccount.members.filter((m) => m.licenseAssigned === true) : [];
      if (context.currentReview && context.currentReview.members) {
        members = members.filter((m) => context.currentReview.members.filter((member) => member.memberId === m.memberId).length === 0);
      }

      return members;
    },
  },
  mounted() {
    this.loadAccountInfo();
  },
  methods: {
    loadAccountInfo() {
      this.$store
        .dispatch("billing/getBillingAccountInfo")
        .then((response) => {})
        .finally(() => {});
    },
    handleSendInvite() {
      let context = this;
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      context.sending = true;

      let reviewId = context.$store.state.review.currentReview.id;

      let form = context.$refs.InviteForm as any;
      form.validate((valid: boolean) => {
        if (valid) {
          context.$store
            .dispatch("review/inviteMember", {
              data: {
                memberId: context.inviteModel.memberId,
                role: context.inviteModel.role,
                beOwner: false,
                reviewId: reviewId,
              },
            })
            .then((response) => {
              context.$store.dispatch("review/get", {
                id: reviewId,
              });
              context.currentPage = "members";
            })
            .finally(() => {
              context.sending = false;
              target.disabled = false;
            });
        } else {
          target.disabled = false;
          context.sending = false;
        }
      });
    },
    showInviteUser() {
      this.inviteModel.memberId = null;
      this.inviteModel.role = null;

      this.currentPage = "invite";
    },
    assignCurrentMember(member) {
      this.changingRoleByUser = false;
      this.currentMember = Object.assign({}, member);
      this.currentMemberOriginalRole = member.role;
      this.changingRoleByUser = true;
    },
    handleChangeRole(role) {
      let context = this;
      if (context.changingRoleByUser) {
        if (context.currentMemberOriginalRole == 1 || context.currentMemberOriginalRole == 2) {
          Modal.confirm({
            title: "Change Users Review Role?",
            content: "<p>This user may have historical check-in data in this review. If you proceed with this role change, the check-in data will be lost.</p><p>Do you want to proceed?</p>",
            okText: "Proceed with role change",
            cancelText: "Never mind",
            onOk: () => {
              context.updateMemberRole(role);
            },
            onCancel: () => {
              context.changingRoleByUser = false;
              context.currentMember.role = context.currentMemberOriginalRole;
              context.changingRoleByUser = true;
            },
          });
        } else {
          context.updateMemberRole(role);
        }
      }
    },
    updateMemberRole(role) {
      let context = this;
      let reviewId = context.$store.state.review.currentReview.id;

      let data = {
        email: context.currentMember.memberEmailAddress,
        role: role,
        reviewId: reviewId,
        memberId: context.currentMember.memberId,
      };

      this.$store
        .dispatch("review/updateMember", {
          data: data,
        })
        .then((response) => {
          context.$store.dispatch("review/get", {
            id: reviewId,
          });
          context.currentMemberOriginalRole = role;
          context.currentMember.role = role;
        })
        .catch((error) => {
          context.changingRoleByUser = false;
          context.currentMember.role = context.currentMemberOriginalRole;
          context.changingRoleByUser = true;
        });
    },
    handleRemove() {
      let reviewId = this.$store.state.review.currentReview.id;
      let context = this;
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let data = {
        email: context.currentMember.memberEmailAddress,
        reviewId: reviewId,
      };
      if (context.currentMember.memberId) {
        (data as any).memberId = context.currentMember.memberId;
      }

      let popupContent =
        context.currentMemberOriginalRole == 1 || context.currentMemberOriginalRole == 2
          ? "<p>This user may have historical check-in data in this review. If you proceed with removing this user the check-in data will be lost. Do you want to proceed?</p>"
          : "<p>You are about to move this user's access to this review. Do you want to proceed?</p>";
      Modal.confirm({
        title: "Remove User From Review?",
        content: popupContent,
        okText: "Proceed with user removal",
        cancelText: "Never mind",
        onOk: () => {
          context.removeMember(data, () => {
            target.disabled = false;
          });
        },
        onCancel: () => {
          target.disabled = false;
        },
      });
    },
    removeMember(removeInput, callback) {
      let context = this;
      context.$store
        .dispatch("review/removeMember", {
          data: removeInput,
        })
        .then((response) => {
          context.$store.dispatch("review/get", {
            id: removeInput.reviewId,
          });
          context.$emit("cancel");
        })
        .finally(() => {
          if (callback) {
            callback();
          }
        });
    },
    handleMemberClick(member) {
      this.currentPage = "member";
      this.assignCurrentMember(member);
    },
    handleBackClick() {
      if (this.currentPage == "member" || this.currentPage == "invite") {
        this.currentPage = "members";
      } else {
        this.currentPage = "member";
      }
    },
  },
});
